import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import DataField from "../../utils/DataField"
import AnalysisStatus from "../AnalysisStatusBox/AnalysisStatus/AnalysisStatus"
import AdditionalDriversListDialog from "./AdditionalDriversListDialog"
import { extractRentalAgreementParties } from "../../utils/utils"
import { aggregatePartyStatusSummary } from "../PartyDetails/partyStatus"

function AdditionalDriversCard(props) {
    const { t } = useTranslation()
    const [dialogOpen, setDialogOpen] = useState(false)

    const { additionalDrivers } = extractRentalAgreementParties(props.rental_agreement)
    const statusSummary = aggregatePartyStatusSummary(additionalDrivers)
    const statusFraction = statusSummary && statusSummary.matching < statusSummary.total
        ? t("party_status_fraction", { matching: statusSummary.matching, total: statusSummary.total })
        : null

    return (
        <div className="analysisCard">
            <div className={["blueText", "subtitleSize"].join(" ")}>
                {t("additional_drivers")}
            </div>
            {additionalDrivers.length === 0 ?
                <div
                    className={["labelText", "normalMediumSize"].join(" ")}
                    style={{ margin: "10px 0px" }}
                >
                    {t("no_additional_drivers")}
                </div>
                :
                <div className="labelSpace">
                    <DataField
                        title={t("drivers_quantity")}
                        label={String(additionalDrivers.length)}
                        size={"normalMediumSize"}
                        titleNoWrap={true}
                        margin="10px"
                    />
                    <AnalysisStatus
                        name={t("analysis_status")}
                        status={statusSummary && statusSummary.status}
                        suffix={statusFraction}
                    />
                    <div
                        onClick={() => setDialogOpen(true)}
                        className={["blueText", "normalSmallSize", "link"].join(" ")}
                        style={{ margin: "10px 0px" }}
                    >
                        {t("details")}
                    </div>
                    <AdditionalDriversListDialog
                        open={dialogOpen}
                        onClose={() => setDialogOpen(false)}
                        drivers={additionalDrivers}
                    />
                </div>
            }
        </div>
    )
}

export default AdditionalDriversCard
